/**
 * @generated SignedSource<<5e105c4875bd9d2a55574f661ba0eaa9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type areFiltersApplied_itemSearch$data = {
  readonly appliedFilters: ReadonlyArray<{
    readonly name: string | null;
  } | null> | null;
  readonly " $fragmentType": "areFiltersApplied_itemSearch";
};
export type areFiltersApplied_itemSearch$key = {
  readonly " $data"?: areFiltersApplied_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"areFiltersApplied_itemSearch">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "areFiltersApplied_itemSearch"
};

(node as any).hash = "8b7ffd7dbe40102222f4f22dbc7f7799";

export default node;
